//@flow
import { formatMomentObjectWithValue } from '../../Utils/dateUtil'
import { YES_ANSWER, NO_ANSWER,YES,NO } from '../../views/ProjectGorgon/common/variables';
import type { 
    InputFormData, MemEmpDetail, ApplicationDetail, ApplicationInfo, Coverage, PhysicianInfo,
    InputFormQuestion,FormQuestion,AddQuestion, ReviewAnswer
} from './flowTypes'

export const formatDatePickerValue=(formValue:moment$Moment)=>{
    const outputDateFormat='YYYY-MM-DD'
    return formatMomentObjectWithValue(formValue,outputDateFormat)
}

export const getMemberEmployeeDetail=(formData: InputFormData)=>{
    const memEmpDetail:MemEmpDetail = {
        memEmpNameOfGroup: formData.memEmpNameOfGroup?formData.memEmpNameOfGroup:'',
        memEmpNameOfAgency: formData.memEmpNameOfAgency?formData.memEmpNameOfAgency:'',
        memEmpGroupNumber: formData.memEmpGroupNumber?formData.memEmpGroupNumber:'',
        memEmpCheckWhoIsApply: formData.memEmpCheckWhoIsApply?formData.memEmpCheckWhoIsApply:'',
        isOverrideMemEmpCheckWhoIsApply: formData.isOverrideMemEmpCheckWhoIsApply?formData.isOverrideMemEmpCheckWhoIsApply:false,
        memEmpFirstName: formData.memEmpFirstName?formData.memEmpFirstName:'',
        isOverrideMemEmpFirstNameNotFound: formData.isOverrideMemEmpFirstNameNotFound?formData.isOverrideMemEmpFirstNameNotFound:false,
        memEmpMiddleName: formData.memEmpMiddleName?formData.memEmpMiddleName:'',
        memEmpLastName: formData.memEmpLastName?formData.memEmpLastName:'',
        isOverrideMemEmpLastNameNotFound: formData.isOverrideMemEmpLastNameNotFound?formData.isOverrideMemEmpLastNameNotFound:false,
        memEmpNameSuffix: formData.memEmpNameSuffix?formData.memEmpNameSuffix:'',
        memEmpBirthdate: formData.memEmpBirthdate?formatDatePickerValue(formData.memEmpBirthdate):'',
        memEmpDatehired: formData.memEmpDatehired?formatDatePickerValue(formData.memEmpDatehired):'',
        memEmpOccupation: formData.memEmpOccupation?formData.memEmpOccupation:'',
        memEmpSalary: formData.memEmpSalary?formData.memEmpSalary:'',
        memEmpSSN: formData.memEmpSSN?formData.memEmpSSN:'',
        memEmpIdentificationNum: formData.memEmpIdentificationNum?formData.memEmpIdentificationNum:''
    }    
    return memEmpDetail;
}

export const getApplicantDetail=(formData: InputFormData)=>{
    const appDetail:ApplicationDetail={
        appFirstName: formData.appFirstName?formData.appFirstName:'',
        isOverrideAppFirstNameNotFound: formData.isOverrideAppFirstNameNotFound?formData.isOverrideAppFirstNameNotFound:false,
        appMiddleName: formData.appMiddleName?formData.appMiddleName:'',
        appLastName: formData.appLastName?formData.appLastName:'',
        isOverrideAppLastNameNotFound: formData.isOverrideAppLastNameNotFound?formData.isOverrideAppLastNameNotFound:false,
        appNameSuffix: formData.appNameSuffix?formData.appNameSuffix:'',
        appEmail: formData.appEmail?formData.appEmail:'',
        appStreetAddrLine1: formData.appStreetAddrLine1?formData.appStreetAddrLine1:'',
        isOverrideAppStreetAddrLine1NotFound: formData.isOverrideAppStreetAddrLine1NotFound?formData.isOverrideAppStreetAddrLine1NotFound:false,
        appStreetAddrLine2: formData.appStreetAddrLine2?formData.appStreetAddrLine2:'',
        appCity: formData.appCity?formData.appCity:'',
        isOverrideAppCityNotFound: formData.isOverrideAppCityNotFound?formData.isOverrideAppCityNotFound:false,
        appState: formData.appState?formData.appState:'',
        isOverrideAppStateNotFound: formData.isOverrideAppStateNotFound?formData.isOverrideAppStateNotFound:false,
        appZip: formData.appZip?formData.appZip:'',
        isOverrideAppZipNotFound: formData.isOverrideAppZipNotFound?formData.isOverrideAppZipNotFound:false,
        appCountry: formData.appCountry?formData.appCountry:'',
        appSex: formData.appSex?formData.appSex:'',
        isOverrideAppSexNotFound: formData.isOverrideAppSexNotFound?formData.isOverrideAppSexNotFound:false,
        appBirthdate: formData.appBirthdate?formatDatePickerValue(formData.appBirthdate):'',
        appBirthplaceState: formData.appBirthplaceState?formData.appBirthplaceState:'',
        appBirthplaceCountry: formData.appBirthplaceCountry?formData.appBirthplaceCountry:'',
        appSSN: formData.appSSN?formData.appSSN:'',
        appWorkPhoneNum: formData.appWorkPhoneNum?formData.appWorkPhoneNum:'',
        isOverrideAppWorkPhoneNumNotFound: formData.isOverrideAppWorkPhoneNumNotFound?formData.isOverrideAppWorkPhoneNumNotFound:false,
        appWorkPhoneExt: formData.appWorkPhoneExt?formData.appWorkPhoneExt:'',
        appHomePhoneNum: formData.appHomePhoneNum?formData.appHomePhoneNum:'',
        isOverrideAppHomePhoneNumNotFound: formData.isOverrideAppHomePhoneNumNotFound?formData.isOverrideAppHomePhoneNumNotFound:false,
        appHomePhoneExt: formData.appHomePhoneExt?formData.appHomePhoneExt:'',
        isOverrideAppCountry: formData.isOverrideAppCountry?formData.isOverrideAppCountry:false,
        isOverrideAppBirthplaceCountry: formData.isOverrideAppBirthplaceCountry?formData.isOverrideAppBirthplaceCountry:false
    }    
    return appDetail;
}

export const getApplicationInfo=(formData:InputFormData,formAppCoverages:Array<any>)=>{
    //Special Handle for Application Type
    let applicationType = formData.appInfoApplicationType?formData.appInfoApplicationType:''
    if (applicationType && applicationType == 'Empty'){
        applicationType = ''
    }

    let appInfo:ApplicationInfo={
        appInfoApplicationType: applicationType,
        coverages: []
    }
    
    formAppCoverages.forEach(formAppCoverage => {
        
        const appInfoCoverageRequested=`appInfoCoverageRequested${formAppCoverage.formId}`
        const appInfoCurrentAmtInForce=`appInfoCurrentAmtInForce${formAppCoverage.formId}`
        const appInfoAdditionalAmtReq=`appInfoAdditionalAmtReq${formAppCoverage.formId}`
        const appInfoTotalAmtReq=`appInfoTotalAmtReq${formAppCoverage.formId}`

        let coverage:Coverage={
            planName: formData[appInfoCoverageRequested],
            currentAmount: formData[appInfoCurrentAmtInForce],
            additionalAmount: formData[appInfoAdditionalAmtReq],
            totalAmount: formData[appInfoTotalAmtReq]
        }
        
        appInfo.coverages.push(coverage)
    })
    
    return appInfo;
}

export const getPhysicianInfo=(formData:InputFormData)=>{
    const physicianInfo:PhysicianInfo={
        physicianFirstName: formData.physicianFirstName?formData.physicianFirstName:'',
        physicianLastName: formData.physicianLastName?formData.physicianLastName:'',
        physicianClinicName: formData.physicianClinicName?formData.physicianClinicName:'',
        physicianAddrLine1: formData.physicianAddrLine1?formData.physicianAddrLine1:'',
        physicianAddrLine2: formData.physicianAddrLine2?formData.physicianAddrLine2:'',
        physicianCity: formData.physicianCity?formData.physicianCity:'',
        physicianState: formData.physicianState?formData.physicianState:'',
        physicianZip: formData.physicianZip?formData.physicianZip:'',
        physicianPhoneNum: formData.physicianPhoneNum?formData.physicianPhoneNum:'',
        lastConsultDate: formData.lastConsultDate?formatDatePickerValue(formData.lastConsultDate):'',
        lastConsultReason: formData.lastConsultReason?formData.lastConsultReason:''
    }
    return physicianInfo;
}

export const getMedicalHistoryQuestions=(formQuestions:Array<InputFormQuestion>,formData:any)=>{
    let questions:Array<FormQuestion>=[];
    
    formQuestions.map((formQuestion)=>{
        if (formQuestion.has_answer_response){
            const yesAnswerElement=`${YES_ANSWER}${formQuestion.question_id}`
            const noAnswerElement=`${NO_ANSWER}${formQuestion.question_id}`

            let mhsQuestion:FormQuestion={
                id: formQuestion.question_id,
                responseData: ''
            };
            
            if (formData[yesAnswerElement] && formData[yesAnswerElement]==true){
                mhsQuestion.responseData='Y';
            }
            if (formData[noAnswerElement] && formData[noAnswerElement]==true){
                mhsQuestion.responseData='N';
            }

            questions.push(mhsQuestion);

        }
    })    

    return questions;
}

export const getAdditionalQuestions=(formData: InputFormData)=>{
    const addQuestions: AddQuestion = {
        heightFeet: formData.heightFeet,
        heightInches: formData.heightInches,
        weight: formData.weight,
        applicantSignatureDate: formData.applicantSignatureDate?formatDatePickerValue(formData.applicantSignatureDate):'',
        isOverrideApplicantSignatureDateNotFound: formData.isOverrideApplicantSignatureDateNotFound,
        isThereApplicantSignature: formData.isThereApplicantSignature?formData.isThereApplicantSignature:false
    }
    
    return addQuestions;
}

export const getReviewOutcome=(formData: InputFormData,reviewQuestions: Array<any>)=>{
    let reviewAnswers:Array<ReviewAnswer> = []

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect' && formData[question.elementId]){
            const newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: formData[question.elementId],
                subAnswers: []
            }
            reviewAnswers.push(newReviewAnswer)
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_Yes`
            const noElement = `${question.elementId}_No`

            let newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: '',
                subAnswers: []
            }

            if (formData[noElement]){
                newReviewAnswer.answer = NO
                reviewAnswers.push(newReviewAnswer)   
            }else {
                newReviewAnswer.answer = YES
                question.yesSubAnswers.map(subAnswer=>{
                    if (formData[subAnswer.field]){
                        newReviewAnswer.subAnswers.push(subAnswer.field)
                    }
                })
                reviewAnswers.push(newReviewAnswer) 
            }
        }
    })

    return reviewAnswers
}


// WEBPACK FOOTER //
// ./src/redux/gorgon/submitFormData.js